import { DOGMA_LAST_UPDATED_AT_S3_PREFIX, DOGMA_S3_PREFIX, FinTechOpsCategories } from '../../FinTechOpsConstants';
import { returnParsedAndFormattedDogmaData } from '../../dogma/DogmaDataProcessing';
import { DogmaParsedDetails, DogmaRawData } from '../../dogma/DogmaInterface';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const useDogmaData = (): UseS3DatasetResult<DogmaParsedDetails> =>
  useS3Dataset<DogmaRawData[], DogmaParsedDetails>({
    prefix: DOGMA_S3_PREFIX,
    lastUpdatedPrefix: DOGMA_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.dogma,
    parse: returnParsedAndFormattedDogmaData
  });
